import { type SVGProps } from 'react';

export function GhostBadgeCardSvg(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 140 203"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M118 0C130.15 0 140 9.85 140 22V180.667C140 192.817 130.15 202.667 118 202.667H22C9.85 202.667 0 192.817 0 180.667V22C0 9.85 9.85 0 22 0H118ZM49.33 13.78C46.88 13.78 44.89 15.77 44.89 18.22C44.89 20.68 46.88 22.67 49.33 22.67H90.66C93.12 22.67 95.11 20.68 95.11 18.22C95.11 15.77 93.12 13.78 90.66 13.78H49.33Z"
        fill="#F9F4F1"
      />
    </svg>
  );
}
